import { render, staticRenderFns } from "./TrainerFilters.vue?vue&type=template&id=349f3a42"
import script from "./TrainerFilters.vue?vue&type=script&lang=js"
export * from "./TrainerFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports